import { getCookie } from 'cookies-next';
import { TYPE_CONSTANT } from '../../constant/Web_constant';

import { dynamic_text_convert } from '../../utils/dynamicTextConvert';
import { get_data_by_current_language } from '../../utils/GetDataByLanguage';
import UserFirstName from './UserFirstName';
import UserLastName from './UserLastName';
import UserProfileImage from './UserProfileImage';

//  component_decide
export const dynamic_user_card_block_decide = ({
  order_number,
  block,
  block_code,
  block_data_key,
  fetch_by,
  data,
  isStatic,
  extra_data,
  styles,
  screen_width: width,
  isEnabled = true,
  user,
}) => {
  const _styles = styles ?? data?.styles ?? {};
  const section = {
    order_number,
    block,
    block_data_key,
    fetch_by,
    data,
    isStatic,
    extra_data,
    styles,
  };

  switch (block) {
    case 'user_first_name':
      return <UserFirstName data={data} styles={styles} user={user} />;
    case 'user_last_name':
      return <UserLastName data={data} styles={styles} user={user} />;
    case 'user_profile_image':
      return <UserProfileImage data={data} styles={styles} user={user} />;

    default:
      break;
  }
};
